<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                {{id? 'Dettaglio': 'Nuova'}} Voce di spesa predefinita
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Voce di spesa" :errors="getErrors('voce_spesa')">
                    <VueMultiselect
                        v-model="vocespesaAutocomplete.selection"
                        :options="vocespesaAutocomplete.options"
                        placeholder="Voce di spesa"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="descrizione"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="vocespesaAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Business unit" :errors="getErrors('business_unit')">
                    <VueMultiselect
                        v-model="buAutocomplete.selection"
                        :options="buAutocomplete.options"
                        placeholder="Business unit"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="nome"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="buAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Aliquota acquisto" :errors="getErrors('iva_acquisto')">
                    <VueMultiselect
                        v-model="aliquotaAcAutocomplete.selection"
                        :options="aliquotaAcAutocomplete.options"
                        placeholder="IVA acquisto"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="descrizione"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="aliquotaAcAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Aliquota vendita" :errors="getErrors('iva_vendita')">
                    <VueMultiselect
                        v-model="aliquotaVeAutocomplete.selection"
                        :options="aliquotaVeAutocomplete.options"
                        placeholder="IVA vendita"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="descrizione"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="aliquotaVeAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div class="flex pt-3 justify-between">
                <div>
                    <NextButton v-show="id" class="px-3 py-2" @click="cancella">Cancella</NextButton>
                </div>
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Autocomplete from "@/setup/Autocomplete";
import {mapGetters} from 'vuex';
import voceSpesaManager from "@/api/VoceSpesaManager";
import aliquotaManager from "@/api/AliquotaManager";
import businessUnitsManager from "@/api/BusinessUnits";
import voceSpesaBusinessUnitIvaManager from "@/api/VoceSpesaBusinessUnitIvaManager";

@Options({
    name: 'DettaglioVociSpesaBusinessUnitsIva',
    components: {
        MultiselectOption, NextButton,
        Loading,
        Field,
        NextTable,
        InfiniteLoading,

    },
    props: {
        id: {
            type: [String, Number],
            required: false
        },
    },
    computed: {
        ...mapGetters('buFieldModule', [
            'allField',
            'cellsDescriptor',
            'isCellAcquisto',
            'isCellVendita',
            'isCellRe',
            'isCellNe',
        ]),
    }
})
export default class BusinessUnitsDetail extends Vue {
    vocespesaAutocomplete: any = setup(() => Autocomplete(voceSpesaManager))
    aliquotaAcAutocomplete: any = setup(() => Autocomplete(aliquotaManager))
    aliquotaVeAutocomplete: any = setup(() => Autocomplete(aliquotaManager))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, false, {crm: 1}))

    id!: number

    esito = false
    response_message = ''
    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }


    created(){
        if(this.id) {
            voceSpesaBusinessUnitIvaManager.retrieve(this.id).then((res) => {
                this.vocespesaAutocomplete.retrieve(res.data.voce_spesa_id)
                this.buAutocomplete.retrieve(res.data.business_unit_id)
                this.aliquotaAcAutocomplete.retrieve(res.data.iva_acquisto_id)
                this.aliquotaVeAutocomplete.retrieve(res.data.iva_vendita_id)
            })
        }
        this.vocespesaAutocomplete.search('', 0)
        this.buAutocomplete.search('', 0)
        this.aliquotaAcAutocomplete.search('', 0)
        this.aliquotaVeAutocomplete.search('', 0)
    }

    mounted(){
        this.esito = false
        this.response_message = ''
    }

    save(){
        if(this.id){
            voceSpesaBusinessUnitIvaManager.update(this.id, {
                voce_spesa: this.vocespesaAutocomplete.selection?.id,
                business_unit: this.buAutocomplete.selection?.id,
                iva_acquisto: this.aliquotaAcAutocomplete.selection?.id,
                iva_vendita: this.aliquotaVeAutocomplete.selection?.id,
            }).then(()=>{
                this.esito = true
                this.response_message = 'Salvataggio avvenuto corretamente'
            }).catch((res)=>{
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        } else {
            voceSpesaBusinessUnitIvaManager.create({
                voce_spesa: this.vocespesaAutocomplete.selection?.id,
                business_unit: this.buAutocomplete.selection?.id,
                iva_acquisto: this.aliquotaAcAutocomplete.selection?.id,
                iva_vendita: this.aliquotaVeAutocomplete.selection?.id,
            }).then((res:any)=>{
                //@ts-ignore
                this.$router.replace({name:'DettaglioVociSpesaBusinessUnitsIva', params:{id:res.data.id}})
            }).catch((res)=>{
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        }

    }

    async cancella(){
        voceSpesaBusinessUnitIvaManager.delete(this.id).finally(()=>{
            //@ts-ignore
            this.$router.replace({name:'VociSpesaBusinessUnitsIva'})
        })
    }

    cols = [
        {
            name: 'Voce di spesa',
            prop: 'descrizione_voce_spesa',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Business unit',
            prop: 'descrizione_bu',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Iva di vendita',
            prop: 'descrizione_iva_vendita',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Iva di acquisto',
            prop: 'descrizione_iva_acquisto',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]

}

</script>


<style lang="scss">

</style>
